<ngb-carousel class="carrousel_header">
	<ng-template ngbSlide *ngFor="let banner of mainBannerService.banners">
		<div>
			<img src="{{banner.url}}" alt="Random first slide" />
		</div>
	</ng-template>
</ngb-carousel>